var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02209 9.63409C6.02209 8.94681 5.46494 8.38965 4.77765 8.38965C4.09036 8.38965 3.5332 8.94681 3.5332 9.63409V10.8785C3.5332 11.5658 4.09036 12.123 4.77765 12.123C5.46494 12.123 6.02209 11.5658 6.02209 10.8785V9.63409Z",
    stroke: "white",
    strokeWidth: 1.176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4886 9.63409C13.4886 8.94681 12.9315 8.38965 12.2442 8.38965C11.5569 8.38965 10.9998 8.94681 10.9998 9.63409V10.8785C10.9998 11.5658 11.5569 12.123 12.2442 12.123C12.9315 12.123 13.4886 11.5658 13.4886 10.8785V9.63409Z",
    stroke: "white",
    strokeWidth: 1.176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5332 9.63412V7.76745C3.5332 6.44726 4.05765 5.18114 4.99116 4.24763C5.92467 3.31412 7.19079 2.78967 8.51098 2.78967C9.83117 2.78967 11.0973 3.31412 12.0308 4.24763C12.9643 5.18114 13.4888 6.44726 13.4888 7.76745V9.63412",
    stroke: "white",
    strokeWidth: 1.176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2441 12.1229C12.2441 12.618 11.8507 13.0928 11.1506 13.4429C10.4505 13.7929 9.50088 13.9896 8.51074 13.9896",
    stroke: "white",
    strokeWidth: 1.176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLesson);
export default __webpack_public_path__ + "static/media/ic_lesson.12d66763f53e36a56b8aa910b0e08e5b.svg";
export { ForwardRef as ReactComponent };